<template>
  <el-dialog v-if="mVisible" :title="title" :visible.sync="mVisible" width="30%">
    <!--    <span>-->
    <!--      <svg-icon :icon-class="information.icon" style="margin-right:10px" />-->
    <!--      {{ information.subTitle }}-->
    <!--    </span>-->
    <div class="Tdialog-content">
      <div class="Tdialog-svg">
        <svg-icon :icon-class="information.icon" style="margin-right:10px" />
      </div>
      <div class="Tdialog-subTitle">{{ information.subTitle }}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <template>
        <div v-if="information.hideCancel" style="display: none;" />
        <el-button v-else @click="mVisible=false">{{ cancelText }}</el-button>

      </template>
      <el-button type="primary" @click="submit">{{ confirmText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DialogMixin from '@/mixin/dialog-mixin';

export default {
  name: 'Dialog',
  mixins: [DialogMixin],
  props: {
    information: {
      type: Object,
      default: () => {
        return {};
      },
    },
    cancelText: {
      type: String,
      default: '取 消',
    },
    confirmText: {
      type: String,
      default: '确 定',
    },
  },
  data() {
    return {};
  },
  methods: {
    submit() {
      this.mVisible = false;
      this.$emit('submit-success', this.information.operation);
    },
  },
};
</script>
<style lang="less">
.Tdialog-content {
  display: flex;

  line-height: 24px;
  .Tdialog-svg {
    width: 21px;
    height: 21px;
  }
}
</style>
